var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:[_vm.data.class, _vm.data.staticClass],domProps:{"innerHTML":_vm._s(_vm.$options.methods.applyStyle(_vm.props.markdown))}})}
var staticRenderFns = []

export { render, staticRenderFns }